(function () {
  function init(root) {
    const track = root.querySelector("[data-xav-test-track]");
    const dotsWrap = root.querySelector("[data-xav-test-dots]");
    const cards = Array.from(root.querySelectorAll("[data-xav-test-card]"));
    if (!track || !dotsWrap || cards.length === 0) return;

    // Prevent double-init when Shopify reloads sections
    if (root.__xavInitDone) return;
    root.__xavInitDone = true;

    const desktopCols = parseInt(root.getAttribute("data-desktop-cols") || "2", 10);
    root.setAttribute("data-cols", String(desktopCols));

    function colsNow() {
      // Mobile: 1, Desktop: desktopCols
      return window.matchMedia("(min-width: 990px)").matches ? desktopCols : 1;
    }

    function pageCount() {
      return Math.ceil(cards.length / colsNow());
    }

    let page = 0;

    function buildDots() {
      dotsWrap.innerHTML = "";
      const pages = pageCount();

      // If only 1 page, no dots needed
      if (pages <= 1) return;

      for (let i = 0; i < pages; i++) {
        const b = document.createElement("button");
        b.type = "button";
        b.className = "xav-dot" + (i === page ? " is-active" : "");
        b.setAttribute("aria-label", `Go to slide ${i + 1}`);
        b.addEventListener("click", () => go(i));
        dotsWrap.appendChild(b);
      }
    }

    function setActiveDot() {
      const dots = Array.from(dotsWrap.querySelectorAll(".xav-dot"));
      dots.forEach((d, i) => d.classList.toggle("is-active", i === page));
    }

    // ✅ Correct translate math (card + gap) * cols
    function go(nextPage) {
      const cols = colsNow();
      const pages = pageCount();
      page = Math.max(0, Math.min(nextPage, pages - 1));

      const cs = getComputedStyle(track);
      const gap = parseFloat(cs.columnGap || cs.gap || "0") || 0;

      const cardW = cards[0].getBoundingClientRect().width;

      const step = (cardW + gap) * cols;
      const shift = page * step;

      track.style.transform = `translateX(${-shift}px)`;
      track.style.transition = "transform 200ms ease";

      setActiveDot();
    }

    // Drag / swipe
    let startX = 0;
    let dragging = false;

    track.addEventListener("pointerdown", (e) => {
      dragging = true;
      startX = e.clientX;
      track.setPointerCapture(e.pointerId);
      track.style.transition = "none";
    });

    track.addEventListener("pointerup", (e) => {
      if (!dragging) return;
      dragging = false;

      const dx = e.clientX - startX;
      if (Math.abs(dx) > 60) {
        go(dx < 0 ? page + 1 : page - 1);
      } else {
        go(page);
      }
    });

    track.addEventListener("pointercancel", () => {
      dragging = false;
      go(page);
    });

    // Resize rebuild
    const onResize = () => {
      page = 0;
      buildDots();
      go(0);
    };

    window.addEventListener("resize", () => {
      clearTimeout(window.__xavTestResizeT);
      window.__xavTestResizeT = setTimeout(onResize, 150);
    });

    // Start
    buildDots();
    go(0);
  }

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("[data-xav-test]").forEach(init);
  });

  document.addEventListener("shopify:section:load", (event) => {
    const section = event.target;
    if (!section) return;
    section.querySelectorAll("[data-xav-test]").forEach(init);
  });
})();
